'use strict';

var _ = require('lodash');
var SystemStatusToolbarController = function SystemStatusToolbarController($scope, $rootScope, SystemConstants, currentStateCriteriaService, searchCriteriaConstantsService, userSecureService, featureToggleService) {
  var HISTORY_SEARCH_MODES = [];
  var screenName = getFirstAvailableScreen();
  var dynamicAvailabilityEnabled = featureToggleService.isEnabled('DYNAMIC_AVAILABILITY');
  var faresOptimizerEnabled = featureToggleService.isEnabled('FARES_OPTIMIZER');
  var serviceClassControlEnabled = featureToggleService.isEnabled('SERVICE_CLASS_CONTROL');
  var flightOrServiceSent = serviceClassControlEnabled ? searchCriteriaConstantsService.SYSTEM_STATUS_SERVICE_SENT : searchCriteriaConstantsService.SYSTEM_STATUS_FLIGHT_SENT;
  $scope.screen = dynamicAvailabilityEnabled || faresOptimizerEnabled ? searchCriteriaConstantsService.SYSTEM_STATUS_INTERFACE_STATUS : flightOrServiceSent;
  $scope.screen = screenName === SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.FO_FARES_REOPT ? searchCriteriaConstantsService.SYSTEM_STATUS_FARES_REOPT : $scope.screen;
  $scope.selectedBookmark = screenName;
  $scope.searchModes = [];
  $scope.triggerSearch = function () {
    var searchMode = currentStateCriteriaService.getCustomSearchMode();
    if (searchMode) {
      $rootScope.$broadcast('system-status:switch-history-grid', searchMode);
    }
    $rootScope.$broadcast('search-criteria:searchChangeEvent');
  };
  $scope.isSearchButtonVisible = function () {
    return SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.FLIGHT_SENT === $scope.selectedBookmark || SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.SERVICE_SENT === $scope.selectedBookmark || SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.FLIGHT_REOPT === $scope.selectedBookmark || SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.MARKET_REOPT === $scope.selectedBookmark || SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.HISTORY === $scope.selectedBookmark || SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.INTERFACE_STATUS === $scope.selectedBookmark || SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.FO_FARES_REOPT === $scope.selectedBookmark;
  };
  $scope.bookmarks = [{
    label: 'Date Optimization',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.REOPTIMIZATION,
    component: SystemConstants.SCREEN_VALUE.COMPONENT.REOPT,
    ifFeatureEnabled: ['REVENUE_OPTIMIZER']
  }, {
    label: 'Market Optimization',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.MARKET_REOPT,
    component: SystemConstants.SCREEN_VALUE.COMPONENT.MARKET_OPTIMIZATION,
    hideButton: featureToggleService.isEnabled('MAPPED_MODE') && featureToggleService.isDisabled('BREAK_CONNECTIONS'),
    ifFeatureEnabled: ['REVENUE_OPTIMIZER;MD_PREVIEW_REOPT']
  }, {
    label: 'Flight Optimization',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.FLIGHT_REOPT,
    component: SystemConstants.SCREEN_VALUE.COMPONENT.FLIGHT_OPTIMIZATION,
    ifFeatureEnabled: ['REVENUE_OPTIMIZER'],
    ifFeatureDisabled: ['SERVICE_CLASS_CONTROL']
  }, {
    label: 'Demand Initialization',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.REINITIALIZATION,
    component: SystemConstants.SCREEN_VALUE.COMPONENT.DEMAND_INITIALIZATION,
    ifFeatureEnabled: ['REVENUE_OPTIMIZER'],
    ifFeatureDisabled: ['POOLED_SEASONALITY']
  }, {
    label: 'Overbkg Initialization',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.OVERBOOKING,
    component: SystemConstants.SCREEN_VALUE.COMPONENT.OVERBOOKING_INITIALIZATION,
    ifFeatureEnabled: ['REVENUE_OPTIMIZER']
  }, {
    label: 'Flight Sent',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.FLIGHT_SENT,
    component: SystemConstants.SCREEN_VALUE.COMPONENT.FLIGHT_SENT,
    ifFeatureEnabled: ['REVENUE_OPTIMIZER'],
    ifFeatureDisabled: ['SERVICE_CLASS_CONTROL']
  }, {
    label: 'Service Sent',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.SERVICE_SENT,
    component: SystemConstants.SCREEN_VALUE.COMPONENT.SERVICE_SENT,
    ifFeatureEnabled: ['REVENUE_OPTIMIZER;SERVICE_CLASS_CONTROL']
  }, {
    label: 'History',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.HISTORY,
    component: SystemConstants.SCREEN_VALUE.COMPONENT.HISTORY,
    ifFeatureEnabled: ['REVENUE_OPTIMIZER']
  }, {
    label: 'Interface Status',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.INTERFACE_STATUS,
    component: SystemConstants.SCREEN_VALUE.COMPONENT.INTERFACE_STATUS,
    ifFeatureEnabled: ['FARES_OPTIMIZER,DYNAMIC_AVAILABILITY']
  }, {
    label: 'Fares Reoptimization',
    value: SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.FO_FARES_REOPT,
    component: SystemConstants.SCREEN_VALUE.COMPONENT.FARES_REOPTIMIZATION,
    ifFeatureEnabled: ['FARES_OPTIMIZER']
  }];
  $scope.setupBookmarks = function () {
    $scope.bookmarks = _.filter($scope.bookmarks, featureToggleService.isEnabledBasedOnConfig);
  };
  $scope.setupBookmarks();
  function getFirstAvailableScreen() {
    if (featureToggleService.isEnabled('REVENUE_OPTIMIZER')) {
      if (userSecureService.hasAuthorization(SystemConstants.SCREEN_VALUE.COMPONENT.REOPT)) {
        return SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.REOPTIMIZATION;
      } else if (userSecureService.hasAuthorization(SystemConstants.SCREEN_VALUE.COMPONENT.FLIGHT_OPTIMIZATION)) {
        return SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.FLIGHT_REOPT;
      } else if (userSecureService.hasAuthorization(SystemConstants.SCREEN_VALUE.COMPONENT.MARKET_OPTIMIZATION)) {
        return SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.MARKET_REOPT;
      } else if (userSecureService.hasAuthorization(SystemConstants.SCREEN_VALUE.COMPONENT.DEMAND_INITIALIZATION)) {
        return SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.REINITIALIZATION;
      } else if (userSecureService.hasAuthorization(SystemConstants.SCREEN_VALUE.COMPONENT.OVERBOOKING_INITIALIZATION)) {
        return SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.OVERBOOKING;
      } else if (userSecureService.hasAuthorization(SystemConstants.SCREEN_VALUE.COMPONENT.FLIGHT_SENT)) {
        return SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.FLIGHT_SENT;
      } else if (userSecureService.hasAuthorization(SystemConstants.SCREEN_VALUE.COMPONENT.SERVICE_SENT)) {
        return SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.SERVICE_SENT;
      } else if (userSecureService.hasAuthorization(SystemConstants.SCREEN_VALUE.COMPONENT.HISTORY)) {
        return SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.HISTORY;
      }
    } else if (featureToggleService.isEnabled('DYNAMIC_AVAILABILITY') || featureToggleService.isEnabled('FARES_OPTIMIZER')) {
      return SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.INTERFACE_STATUS;
    }
  }
  $scope.$watch('selectedBookmark', function () {
    $rootScope.$broadcast('system-status:modeChanged', $scope.selectedBookmark);
    $scope.searchModes = [];
    if ($scope.selectedBookmark === SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.FLIGHT_REOPT) {
      $scope.screen = searchCriteriaConstantsService.SYSTEM_STATUS_FLIGHT_REOPT;
    } else if ($scope.selectedBookmark === SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.MARKET_REOPT) {
      $scope.screen = searchCriteriaConstantsService.SYSTEM_STATUS_MARKET_REOPT;
    } else if ($scope.selectedBookmark === SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.FLIGHT_SENT) {
      $scope.screen = searchCriteriaConstantsService.SYSTEM_STATUS_FLIGHT_SENT;
    } else if ($scope.selectedBookmark === SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.SERVICE_SENT) {
      $scope.screen = searchCriteriaConstantsService.SYSTEM_STATUS_SERVICE_SENT;
    } else if ($scope.selectedBookmark === SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.HISTORY) {
      $scope.searchModes = HISTORY_SEARCH_MODES;
      $scope.screen = searchCriteriaConstantsService.SERVICE_STATUS_HISTORY_MARKET;
      $rootScope.$broadcast('$stateChangeSuccess');
    } else if ($scope.selectedBookmark === SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.FO_FARES_REOPT) {
      $scope.screen = searchCriteriaConstantsService.SYSTEM_STATUS_FARES_REOPT;
    } else if ($scope.selectedBookmark === SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.INTERFACE_STATUS) {
      $scope.screen = searchCriteriaConstantsService.SYSTEM_STATUS_INTERFACE_STATUS;
    }
  });
  $scope.$on('$stateChangeSuccess', function (event, toState, toParams) {
    if (toParams && toParams.transitionData) {
      var action = toParams.transitionData['system-status:force-tab'];
      if (action) {
        $scope.selectedBookmark = action.tabId || screenName;
      } else {
        $scope.selectedBookmark = screenName;
      }
    }
  });
  $scope.adjustmentHistorySearchMode = function (mode) {
    $scope.screen = mode;
  };
  $scope.getHistorySearchModes = function () {
    var searchModes = [{
      label: 'Market',
      mode: SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.HISTORY_MODE.MARKET
    }, {
      label: 'Flight',
      mode: SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.HISTORY_MODE.FLIGHT
    }, {
      label: 'Service',
      mode: SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.HISTORY_MODE.SERVICE
    }];
    if (featureToggleService.isEnabled('FIM')) {
      searchModes.push({
        label: 'Fares',
        mode: SystemConstants.SCREEN_VALUE.SYSTEM_STATUS.HISTORY_MODE.FARES
      });
    }
    return searchModes;
  };
  HISTORY_SEARCH_MODES = $scope.getHistorySearchModes();
};
SystemStatusToolbarController.$inject = ['$scope', '$rootScope', 'SystemConstants', 'CurrentStateCriteriaService', 'SearchCriteriaConstantsService', 'UserSecureService', 'FeatureToggleService'];
module.exports = SystemStatusToolbarController;